import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
  setRemovedDevices,
  setAddedDevices
} from '#action/project/devices-popup';
import { mergeWithAlerts } from '#component/device/devices-popup/helper';
import { RemoveButton, AddButtonLabel } from '#component/device/devices-popup/styles';

const DeleteDevicesButton = props => {
  const {
    selected,
    setSelected,
    data,
    alertId,
    selectedAlert,
    project,
    addMode,
    fetchDevices,
    setFormDevices,
    formDevices: propsFormDevices
  } = props;
  const dispatch = useDispatch();
  const {
    removedDevices,
    newlyAddedDevices
  } = useSelector(s => s.projectDevicesPopup, shallowEqual);

  // Devices are supplied by the RHF-based cargo form
  const cargoDevices = propsFormDevices ?? data?.formDevices ?? [];

  const handleRemoveFormDevices = async () => {
    const selectedIds = selected.map(s => s.id);
    let newDevicesData = cargoDevices.filter(d => !selectedIds.includes(d.id));
    const newAddedDevices = newlyAddedDevices.filter(d => !selectedIds.includes(d.id));

    if (alertId) {
      newDevicesData = mergeWithAlerts(newDevicesData, selectedAlert);
    }

    const newGroup = {
      ...data,
      formDevices: newDevicesData,
      applianceGroup: {
        ...data?.applianceGroup,
        devices: newDevicesData
      }
    };

    if (newDevicesData.length < 11) {
      const newDevices = cargoDevices.filter(d => !selectedIds.includes(d.id));
      setFormDevices?.(newDevices);
    } else {
      setFormDevices?.(newDevicesData);
    }

    await dispatch(setAddedDevices(newAddedDevices));
    await dispatch(setRemovedDevices([...removedDevices, ...selected]));

    await dispatch(fetchDevices(project?.id, addMode, true, newGroup));

    setSelected([]);
  };

  return (
    <RemoveButton
      size="small"
      aria-label="Remove"
      onClick={handleRemoveFormDevices}
    >
      <AddButtonLabel>{`Remove selected (${selected?.length})`}</AddButtonLabel>
    </RemoveButton>
  );
};

export default DeleteDevicesButton;
